import { GraphQLClient } from 'graphql-request';

const client = new GraphQLClient(process.env.REACT_APP_GRAPHQL_HEYAT_ENDPOINT);

export function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => client.request<TData, TVariables>(query, variables);
}

export default client;
